/* eslint-disable react-hooks/exhaustive-deps */

import { Loader } from '@fukuri-admins/ui/common';
import { useEffect, useState } from 'react';
import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { fetchApplicationConfiguration } from '../../api/application_configuration';
import { fetchLinkUrl } from '../../api/linkUrl';
import { useConfiguration } from '../../contexts/ConfigurationProvider';
import { ROUTES } from '../../utils/routes';
import { useAuth } from './AuthProvider';

export function ProtectedRoute() {
  const { isAuthenticated } = useAuth();
  const location = useLocation();
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState<Error | null>(null);
  const { updateConfiguration } = useConfiguration();
  const { signOut } = useAuth();

  useEffect(() => {
    const fetchConfig = async () => {
      try {
        const config = await fetchApplicationConfiguration(signOut);
        const linkUrlsData = await fetchLinkUrl(signOut);
        updateConfiguration(config, linkUrlsData.link_urls);
        setIsLoading(false);
      } catch (err) {
        setError(err as Error);
        setIsLoading(false);
      }
    };

    if (isAuthenticated) {
      fetchConfig();
    }
  }, []);

  if (!isAuthenticated) {
    return <Navigate to={ROUTES.LOGIN} state={{ from: location }} replace />;
  }

  if (isLoading) {
    return <Loader />;
  }

  if (error) {
    return <div>Error loading configuration</div>;
  }

  return <Outlet />;
}
